<template>
  <div class="col-lg-4 dashboard__box-col">
    <div :class="['box ', color]" v-if="user.is_certyficated">
      <h2 class="h h--2">Certyfikat Geberit Pro</h2>

      <p class="dashboard__points dashboard__points--pro">Ważny do:</p>
      <h3 class="dashboard__points">
        {{ moment(user.certyficate_expire).format("DD.MM.YYYY") }}
      </h3>

      <button
        class="button button__bottom"
        id="show-modal-reneve"
        @click="show('uninvoiced-user-modal')"
      >
        Odnowienie certyfikatu
      </button>

      <modal name="uninvoiced-user-modal">
        <div class="row h-100 text-dark">
          <span
            @click="hide('uninvoiced-user-modal')"
            class="prize__close"
          ></span>
          <div
            class="col-md-1 d-flex justify-content-center align-items-center uncertified-user-modal__img"
          ></div>
          <div
            class="col-md-10 d-flex justify-content-center align-items-center uncertified-user-modal__desc"
          >
            <div>
              <h2><strong>Odnowienie certyfikatu</strong></h2>
              <p>
                Odnowienie statusu Certyfikowanego Instalatora wymaga udziału w
                stacjonarnym szkoleniu Certyfikującym Geberit Pro i zaliczenia
                Testu Wiedzy lub 3 (trzech) szkoleń online i zaliczenia
                Skróconych Testów Wiedzy.
              </p>
            </div>
          </div>
        </div>
      </modal>
    </div>

    <div :class="['box ', color]" v-else>
      <h2 class="h h--2">Certyfikat Geberit Pro</h2>
      <p class="dashboard__points dashboard__points--pro">Postęp obrótu:</p>
      <h3 class="dashboard__points">
        {{
          parseFloat(user.certyficate_progress.percent)
            .toFixed(2)
            .replace(".", ",")
        }}
        <span>%</span><br />
      </h3>

      <router-link :to="{ name: 'Rules' }" class="button button__bottom"
        >Zasady programu &raquo;</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "CertyficateWidget",
  props: {
    color: {
      default: "box--dark-blue",
    },
  },
  computed: {
    points() {
      return this.$store.state.user.total_points;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    show(el) {
      this.$modal.show(el);
    },
    hide(el) {
      this.$modal.hide(el);
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/app/home/certyficates/CertyficateWidget.vue